<template>
  <div class="answer-file">
    <div>
      <el-badge is-dot
                :hidden="file && file.src && !file.src.includes('amend')">
                <!-- FIXME: !file.src.includes('amend_normal') -->
        <!-- 图片证据 -->
        <template v-if="type === 'photo'">
          <img :src="file.src|ossThumbnail(75, 'FFFFFF')"
               :alt="file.src">
        </template>
        <template v-if="type === 'qrcode'">
          <div class="qrcode-container">
            <img style="width: 100%; height: 100%; object-fit: contain; margin-bottom: 24px;" :src="file.image_url"
                :alt="file.image_url">
            <div class="qrcode-status" :style="`color: ${file.status === 0 ? 'white' : 'red'}`" >
              <span>{{qrcodeStatus[file.status]}}</span>
              <span id="copyData" @click="e => onCopy(e, file.data)" style="word-break: break-all;">{{file.data}}</span>
            </div>
          </div>
        </template>
        <!-- 视频证据 -->
        <template v-if="type === 'video'">
          <img :src="(file.cover || defaultCover)|ossThumbnail(75, 'FFFFFF')"
               :alt="file.src">
        </template>
        <!-- 录音证据 -->
        <template v-if="type === 'record'">
          <div class="answer-file-icon sj-icon-mp3-file"></div>
        </template>
      </el-badge>
    </div>
    <!-- 选中时显示的图标 -->
    <div v-show="checked"
         class="answer-file-selected-mask">
      <div class="file-selected-container">
        <span class="el-icon-check"></span>
      </div>
    </div>
    <!-- 特殊的图片标识 -->
    <div
      v-if="file && file.scr && file.src.includes('cache')"
      class="answer-file-in-cache">
      <el-tooltip
        :offset="-10"
        :open-delay="200"
        effect="dark"
        content="计时开始时采集的证据，是促销员第一次查询发现不在岗拍摄的照片"
        placement="bottom-start">
        <i class="el-icon-more"></i>
      </el-tooltip>
    </div>

    <div v-if="scene"
         class="scene-badge"
         :title="`${scene.name}-${scene.number}`"
         :style="scene.style">
      {{scene.number}}
    </div>
  </div>
</template>

<script>
import sceneColor from './scene-color'

export default {
  components: {},
  mixins: [],
  props: {
    type: String,
    file: Object,
    index: Number,
    checked: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      defaultCover: 'https://oss-cn-shanghai.aliyuncs.com/taskdescdev/180713/1/df4da0f08d8638d405f937ec5b028d70.png',
      qrcodeStatus: {
        '0': '正常',
        '1': '扫码失败',
        '2': '扫码超时',
        '3': '二维码无效',
      },
    }
  },
  computed: {
    /**
     * 获得场景和序号
     * 例如：
     * http://sjimgpub.slicejobs.com/algapp/order/1269439/15077044/1269439_15077044_Q2022011211063913_5_first_normal_pano_8-1_1651026490731_14819311.jpeg
     * http://sjimgpub.slicejobs.com/algapp/order/1294885/15228881/1294885_15228881_Q202201121105239_8_first_normal_display_16-15_1652502501043_18240430.jpeg
     */
    scene () {
      if (this.file.type === 'photo') {
        /**
         * @type {{'0': string, '1': string, input: string, '2': string, '3': string, length: number, groups: undefined, index: number}|null}
         * @example
         {
            0: "_pano_2-3_",
            1: "pano",
            2: "2",
            3: "3",
            groups: undefined,
            index: 99,
            input: "http://sjimgpubdev.slicejobs.com/algapp/order/166/351227/166_351227_Q202207260140591_3_first_normal_pano_2-3_1658801128981_13451037.jpeg",
            length: 4,
         }
         */
        const result = this.file.src.match(/_(pano|display)_(\d+)-(\d+)_/)
        if (result && result.length === 4) {
          return {
            name: result[2],
            number: result[3],
            style: sceneColor(result[2]),
          }
        }
        const displayResult = this.file.src.match(/_(display)_(\d+)-(\d+)-(\d+)_/)
        if (displayResult && displayResult.length === 5) {
          return {
            name: displayResult[2],
            number: `${displayResult[3]}-${displayResult[4]}`,
            style: sceneColor(displayResult[2]),
          }
        }
      }
      return null
    }
  },
  watch: {},
  beforeCreate () {},
  created () {},
  mounted () {},
  destroyed () {},
  methods: {
    async onCopy (e, data) {
      e.stopPropagation()
      await navigator.clipboard.writeText(data)
      this.$message({
        message: '复制数据成功！',
        type: 'success',
      })
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
$img-size: 75px;
.answer-file {
  position: relative;

  .answer-file-selected-mask {
    background-color: rgba(255, 255, 255, 0.5);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    img {
      display: block;
      width: $img-size;
      height: $img-size;
    }

    .file-selected-container {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
    }

    .el-icon-check {
      font-size: 20px;
      background-color: #67c23a;
      color: white;
      border-radius: 50%;
      padding: 4px;
    }
  }

  .answer-file-in-cache {
    position: absolute;
    bottom: -14px;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    width: 14px;
  }

  .scene-badge {
    position: absolute;
    top: 0;
    left: 0;
    background-color: #000000;
    font-size: 12px;
    color: white;
    padding: 2px 4px;
    border-radius: 3px;
  }

  .qrcode-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    position: relative;
    width: 140px;
    height: 140px;
    .qrcode-status {
      position: absolute;
      font-size: 12px;
      color: #fff;
      margin-top: 2px;
      background-color: rgba(0, 0, 0, 0.7);
      padding: 2px 0px;
      border-radius: 3px;
      bottom: -10px;
      left: 0;
      right: 0;
      width: 100%;
      text-align: center;

      display: flex;
      flex-direction: column;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/question-review/packages/AnswerFileList/AnswerFile.vue